var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.99,
    height: 17.988,
    viewBox: "0 0 17.99 17.988",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M21.96,18.588A15.11,15.11,0,0,0,18.8,16.476c-.946-.454-1.293-.445-1.962.037-.557.4-.918.777-1.559.637a9.3,9.3,0,0,1-3.133-2.318A9.236,9.236,0,0,1,9.831,11.7c-.136-.646.239-1,.637-1.559.482-.67.5-1.016.037-1.962A14.811,14.811,0,0,0,8.393,5.021c-.688-.688-.843-.539-1.222-.4a6.955,6.955,0,0,0-1.119.595A3.376,3.376,0,0,0,4.707,6.632c-.267.576-.576,1.648,1,4.449A24.825,24.825,0,0,0,10.07,16.9h0l0,0,0,0h0A24.922,24.922,0,0,0,15.9,21.276c2.8,1.574,3.873,1.264,4.449,1a3.319,3.319,0,0,0,1.419-1.344,6.955,6.955,0,0,0,.595-1.119C22.5,19.431,22.653,19.276,21.96,18.588Z",
    transform: "translate(-4.49 -4.502)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.58bf5ef2613c09630bad3d4f936964d0.svg";
export { ForwardRef as ReactComponent };